import React, { useEffect } from 'react'
import useApp from 'hooks/useApp'
import { Button, Input } from 'components'

const CertiBring = () => {

	const App = useApp()	

	useEffect(() => {
		App.setHeader({
			show: true,
			title: "인증서 가져오기",
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding">
				<div className="bring-step">
					<div>
						<i className="icon icon_pc" />
						<span className="mt_5">PC</span>
					</div>
					<div>
						<i className="icon icon_mobile" />
						<span className="mt_5">스마트폰</span>
					</div>
				</div>

				<p className="guide-title mt_40">인증번호</p>
				<div className="flex-align_center mt_10">
					<Input type="text" defaultValue="1234" id="" maxlength="4" className="input-center" />
					<span className="mx_10">-</span>
					<Input type="text" defaultValue="1234" id="" maxlength="4" className="input-center" />
					<span className="mx_10">-</span>
					<Input type="text" defaultValue="1234" id="" maxlength="4" className="input-center" />
				</div>

				<div className="bring-guide mt_40">
					<strong>인증서 가져오는 방법</strong>
					<ul>
						<li>1. PC환경에서 아래의 순서대로 진행하세요.
							<ul className="mt_5">
								<li>① www.moneey.co.kr에 접속하세요.</li>
								<li>② 공동인증서 센터에서 [인증서 복사하기]를 선택하세요.</li>
								<li>③ 사용하실 인증서를 선택하고 비밀번호를 입력하세요.</li>
								<li>④ 인증번호 입력란에 위 인증번호 12자리를 입력하세요.</li>
							</ul>
						</li>
						<li>2. 앱 화면 하단의 [인증서 가져오기] 버튼을 선택하세요.</li>
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">인증서 가져오기</Button>
			</div>
		</div>
	)
}

export default CertiBring
